// extracted by mini-css-extract-plugin
export default {"icon":"FeaturePost_icon__-9csD","iconActive":"FeaturePost_iconActive__-d0UD"};